<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56 56"
    class="icon-svg icon-play"
  >
    <path
      fill-rule="evenodd"
      d="M28 4.667C15.126 4.667 4.667 15.127 4.667 28c0 12.874 10.46 23.333 23.333 23.333 12.874 0 23.333-10.46 23.333-23.333 0-12.874-10.46-23.333-23.333-23.333zm0 2.17C39.7 6.837 49.163 16.3 49.163 28c0 11.7-9.462 21.163-21.163 21.163C16.3 49.163 6.837 39.7 6.837 28 6.837 16.3 16.3 6.837 28 6.837zm-4.935 11.379c-.66.027-1.024.62-1.034 1.102v17.364c.005.77 1.01 1.325 1.662.916L37.8 28.933c.628-.387.628-1.462 0-1.849l-14.108-8.699c-.186-.118-.408-.178-.628-.17zm1.137 3.035L35.139 28l-10.937 6.732V21.251z"
      transform="translate(-996 -2182) translate(0 1723) translate(360 80) translate(0 128) translate(612) translate(24 251)"
    />
  </svg>
</template>
